import React from 'react'
import { Link } from "react-router-dom"
import { hook_replace_vars_link } from '../../../services/Hooks'

const AdapterLink = React.forwardRef((props, ref) => {
    let {to} = props
    if( typeof hook_replace_vars_link === 'function' ) {
        to = hook_replace_vars_link(to)
    }
    return <Link innerRef={ref} {...props} to={to} />
})

export default AdapterLink